import axios from "axios";

const ENV_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const sameHost = (() => { try { return new URL(ENV_URL).host === window.location.host; } catch { return false; } })();
// Under a custom domain (e.g. zeeva-pro.com) the ingress serves /api on the same origin — use it to avoid cross-origin/CORS failures.
export const BASE_URL = ENV_URL && sameHost ? ENV_URL : window.location.origin;
export const API = `${BASE_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("zeeva_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e, fallback = "حدث خطأ، حاول مجددًا") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x.msg || JSON.stringify(x)).replace(/^Value error, /, "")).join(" · ");
  if (d.message) return d.missing?.length ? `${d.message}: ${d.missing.join("، ")}` : d.message;
  return d.msg || d.detail || fallback;
}

export function fileUrl(u) {
  if (!u) return "";
  return u.startsWith("/api/") ? `${BASE_URL}${u}` : u;
}
